/**
 * @desc MongoDB操作数据-更新同步状态
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(body: Array<string>, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/task/api/upd/mdbData/status`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
